import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyDashboardBooking({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-7.4%"
          y="-4.4%"
          width="114.7%"
          height="112.3%"
          filterUnits="objectBoundingBox"
          id="pic-empty-dashboard-booking_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-7.4%"
          y="-4.4%"
          width="114.7%"
          height="112.3%"
          filterUnits="objectBoundingBox"
          id="pic-empty-dashboard-booking_svg__c"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <rect id="pic-empty-dashboard-booking_svg__b" x={8} y={7} width={95} height={114} rx={3} />
        <rect id="pic-empty-dashboard-booking_svg__d" x={12} y={4} width={95} height={114} rx={3} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M178.5 155c-40.2-9.93-77 7.5-102 7.5-40.5 0-79.08-37.6-70.5-79C14.03 44.77 72.45 47.8 108 28c109.5-61 112.5 22 126 64s-13 73.5-55.5 63z"
          fill="#E9EDFB"
        />
        <path
          d="M232.85 134.72l-.31.62C223.74 152.48 204 161.3 178.5 155c-40.2-9.93-77 7.5-102 7.5-30.12 0-59.18-20.8-68.56-48.49 24.95 11.65 58.25 13.5 111.56-3.51 62.31-19.89 93.76 2.8 113.35 24.22z"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <g transform="translate(64 23)">
          <g transform="rotate(-8 55.5 64)">
            <use
              fill="#000"
              filter="url(#pic-empty-dashboard-booking_svg__a)"
              xlinkHref="#pic-empty-dashboard-booking_svg__b"
            />
            <use fill="#FAFAFA" xlinkHref="#pic-empty-dashboard-booking_svg__b" />
          </g>
          <use
            fill="#000"
            filter="url(#pic-empty-dashboard-booking_svg__c)"
            xlinkHref="#pic-empty-dashboard-booking_svg__d"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-dashboard-booking_svg__d" />
          <rect fill="#CCD2EE" x={22} y={21} width={24} height={12} rx={2} />
          <path
            d="M51 66a1 1 0 011 1v4a1 1 0 01-1 1H23a1 1 0 01-1-1v-4a1 1 0 011-1h28zm45-13a1 1 0 011 1v4a1 1 0 01-1 1H23a1 1 0 01-1-1v-4a1 1 0 011-1h73zm0-12a1 1 0 011 1v4a1 1 0 01-1 1H23a1 1 0 01-1-1v-4a1 1 0 011-1h73zM36 82a14 14 0 110 28 14 14 0 010-28zm0 1.58a12.42 12.42 0 100 24.84 12.42 12.42 0 000-24.84zm8.25 7.46A8.85 8.85 0 0145.77 96c0 5.12-4.38 9.25-9.77 9.25-1.15 0-2.27-.2-3.32-.55a.8.8 0 01.51-1.5c.9.3 1.84.46 2.81.46 4.53 0 8.19-3.44 8.19-7.66 0-1.46-.44-2.86-1.25-4.07a.8.8 0 111.31-.89zM36 86.75c1.16 0 2.28.2 3.35.56a.8.8 0 01-.52 1.5 8.67 8.67 0 00-2.83-.47c-4.53 0-8.19 3.44-8.19 7.66 0 1.41.41 2.77 1.17 3.95a.8.8 0 01-1.33.86A8.84 8.84 0 0126.23 96c0-5.12 4.38-9.25 9.77-9.25z"
            fill="#E3E8E8"
          />
        </g>
        <path
          d="M144.93 89.4a22.45 22.45 0 00-3.32 30.74c7.25 9.5 21.94 12.29 32.06 3.82l16.37 16.94a1.1 1.1 0 001.56.03l2.21-1.97a1.1 1.1 0 00.03-1.55l-16.37-16.94c6.66-7.35 6.1-21.67-1.5-29.55a22.72 22.72 0 00-31.04-1.51zm1.74 29.6a18 18 0 1125.95-24.95A18 18 0 01146.67 119z"
          fill="#56A"
        />
        <path
          d="M146.67 119a18 18 0 1125.95-24.95A18 18 0 01146.67 119z"
          fill="#FFF"
          opacity={0.72}
        />
        <path
          d="M172.62 94.05a17.92 17.92 0 014.51 8.2 18.3 18.3 0 00-3.07-3.72c-7.65-7.17-20.32-7.4-28.28-.5a18.37 18.37 0 00-3.62 4.22 18 18 0 0130.46-8.2z"
          fill="#8F9DD6"
          opacity={0.3}
        />
      </g>
    </svg>
  );
}

SvgPicEmptyDashboardBooking.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyDashboardBooking.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyDashboardBooking svgRef={ref} {...props} />
));
export default ForwardRef;
